// src/context/AuthContext.js
import React, { createContext, useState, useEffect } from "react";
import api from "../adapters/api";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  // undefined = ยังไม่รู้ผล, null = รู้แล้วว่าไม่ได้ล็อกอิน, object = user info
  const [currentUser, setCurrentUser] = useState(undefined);

  useEffect(() => {
    api
      .get("/api/currentUser", { withCredentials: true })
      .then((res) => {
        if (res.data.loggedIn) setCurrentUser(res.data.user);
        else setCurrentUser(null);
      })
      .catch(() => setCurrentUser(null));
  }, []);

  const login = async (username, password) => {
    const res = await api.post("/api/login", { username, password }, { withCredentials: true });
    if (res.data.loggedIn) {
      setCurrentUser(res.data.user);
    } else {
      throw new Error(res.data.message || "Login failed");
    }
  };

  const logout = async () => {
    await api.post("/api/logout", {}, { withCredentials: true });
    setCurrentUser(null);
  };

  return (
    <AuthContext.Provider value={{ currentUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
